// extracted by mini-css-extract-plugin
module.exports = {"section":"PricingFAQ_section__6KCMv","title":"PricingFAQ_title__s050M"};